import * as React from 'react';

import { Provider } from './context';
import { TScrollingBlocks, TActive, TViewed, IScrollingContext } from './types';
import { useWatchBlocks } from './utils/useWatchBlocks';

export const ScrollingContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [active, setActive] = React.useState<TActive>(null);
  const [viewed, setViewed] = React.useState<TViewed>([]);
  const [refBlocksState, setRefBlocksState] = React.useState<TScrollingBlocks>({});

  const context: IScrollingContext = {
    refBlocksState,
    setRefBlocksState,
    active,
    viewed,
    setActive,
    setViewed,
  };

  useWatchBlocks(context);

  return <Provider value={context}>{children}</Provider>;
};
